import { useMutation } from '@tanstack/react-query';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';

import { getGooglePayProvisionOPCWithoutSigning } from '@domain/digital-wallet';
import { Card } from '@generated-types';

const GOOGLE_WALLET_OPC_PROVISION = 'GOOGLE_WALLET_OPC_PROVISION';

export const useGetOPCGooglePayProvisionMutation = ({
    card,
    walletInfoResult,
}: {
    card: Card;
    walletInfoResult: GtpWalletInfoResult;
}) =>
    useMutation({
        mutationKey: [GOOGLE_WALLET_OPC_PROVISION, walletInfoResult, card],
        mutationFn: () => getGooglePayProvisionOPCWithoutSigning(card, walletInfoResult),
    });
